import get from 'lodash/get'
import request from '../request'
import { createAuthorization } from '../auth'

/**
 * Get terms from brooklyn
 */
export async function getTerms ({ auth, server, value }) {
  const params = {
    searchTerm: value.searchText,
    language: value.language,
    contentType: value.filterType,
  }
  const res = await request
    .get(`${server}/search/autocomplete`)
    .query(params)
    .set('authorization', createAuthorization(auth))
    .set('accept', 'application/json')
    .set('content-type', 'application/json')
  return get(res, 'body', [])
}
